import Link from 'next/link';
import React from 'react';

import { FullLogo } from '@/components/full-logo';


export const Footer = (props: Props) => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="relative h-dvh w-full bg-dark" style={{ zIndex: 30 }}>
      {/* Content Layer - On Top */}
      <div className="absolute inset-0 h-full overscroll-y-contain" style={{ zIndex: 10 }}>
        <div className="flex h-full items-end justify-center">
          <div className="mx-container flex h-full w-full flex-col justify-center desktop:w-10/12 portrait:pb-[5dvh] landscape:pb-[5dvh]">
            <div className="mb-[16px] flex h-full w-full items-center justify-center tablet:mb-[44px]">
              <FullLogo className="desktopXl:mt-[65px] desktopXl:w-[38vw] mobile-only:mt-[60px] mobile-only:w-[65vw] tablet:mt-[70px] tablet:w-[38vw] desktop:mt-[65px] desktop:w-[38vw] desktop4k:mt-[52px] desktop4k:w-[35vw]" />
            </div>

            <div className="grid w-full grid-cols-1 text-center text-[14px] tablet:grid-cols-2 tablet:text-left desktop:text-[11px] desktopXL:text-[18px] desktop4k:text-[22px]">
              <ul className="mb-[12px] flex justify-center space-x-4 text-white tablet:mb-0 tablet:justify-start desktop:space-x-6 desktopXL:space-x-[24px]">
                <li className="cursor-pointer transition-colors hover:text-at hover:underline">
                  <a rel="noopener noreferrer" href="https://dribbble.com/allturtles">
                    Dribbble
                  </a>
                </li>
                <li className="cursor-pointer transition-colors hover:text-at hover:underline">
                  <a rel="noopener noreferrer" href="https://www.linkedin.com/company/allturtlesco/mycompany/">
                    Linkedin
                  </a>
                </li>
              </ul>
              <div className="flex min-w-0 flex-col items-center gap-1 text-white tablet:min-w-max tablet:flex-row tablet:flex-nowrap tablet:justify-end tablet:gap-0 tablet:text-right">
                <span className="tablet:shrink-0">© {currentYear} All Turtles Corporation.</span>
                <span className="whitespace-nowrap tablet:ml-2 tablet:shrink-0">
                  <Link
                    href="/privacy"
                    className="ml-2 cursor-pointer underline transition-colors first:ml-0 hover:text-at"
                  >
                    Privacy
                  </Link>
                  <Link href="/terms" className="ml-2 cursor-pointer underline transition-colors hover:text-at">
                    Terms
                  </Link>
                  <Link
                    href="/patents-and-trademarks"
                    className="ml-2 cursor-pointer underline transition-colors hover:text-at"
                  >
                    Patents and Trademarks
                  </Link>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
